/* HB — Titres communs des grilles de collections, pages normales et intégrées. */
(() => {
  'use strict';
  if (window.HBCollectionHeadings) { window.HBCollectionHeadings.refresh(); return; }
  const selector = '[data-hb-collection-list],.hb-collection-grid,.collection-list,[class*="-categories"]';
  const grids = new Map();
  const shadows = new Map();
  const mobileNavigation = new WeakSet();
  const collectionNavigators = new Map();
  let sequence = 0;
  let config;

  function readConfig() {
    const node = document.getElementById('hb-collections-heading-config');
    if (!node) return false;
    try {
      config = JSON.parse(node.textContent);
      config.text = node.getAttribute('data-title') ?? 'Nos collections';
      return true;
    } catch (_) { return false; }
  }

  function isGrid(node) {
    if (!(node instanceof Element)) return false;
    // Le menu de navigation gauche possède déjà son propre titre et ses réglages.
    if (node.closest('.hbui-sidebar,header,footer')) return false;
    if (node.hasAttribute('data-hb-collection-list') || node.matches('.hb-collection-grid,.collection-list')) return true;
    return Array.from(node.classList).some(name => /^hb[a-z0-9]*-categories$/.test(name));
  }

  function setMobileStrip(grid) {
    // Les onglets des collections gardent leurs liens et leur contrôleur HB.
    // Le menu des catégories et les listes Shopify natives ne sont pas remaniés.
    if (!isGrid(grid) || grid.matches('.collection-list')) return;
    grid.dataset.hbCollectionStrip = '';
    keepCollectionNavigation(grid);
    Array.from(grid.children).forEach(card => {
      if (!card.matches('a,button,.hb-collection-card') && !Array.from(card.classList).some(name => /^hb[a-z0-9]*-category$/.test(name))) return;
      card.dataset.hbCollectionStripCard = '';
      const parts = Array.from(card.children);
      const image = parts.find(node => node.matches('img,.hb-collection-card__image') || Array.from(node.classList).some(name => /^hb[a-z0-9]*-category-image$/.test(name)));
      const copy = parts.find(node => node.matches('.hb-collection-card__copy,h3') || Array.from(node.classList).some(name => /^hb[a-z0-9]*-category-copy$/.test(name)));
      if (image) image.dataset.hbCollectionStripImage = '';
      if (copy) copy.dataset.hbCollectionStripCopy = '';
    });
    // Uniquement les collections des pages catégories, pas les univers.
    if (Array.from(grid.attributes).some(attr => /^data-hb[a-z0-9]*-tabs$/.test(attr.name)) ||
        grid.hasAttribute('data-hb-collection-list')) setupCollectionArrows(grid);
  }

  function setupCollectionArrows(grid) {
    if (collectionNavigators.has(grid)) { collectionNavigators.get(grid).schedule(); return; }
    grid.dataset.hbCollectionNavigationList = '';
    if (!grid.id) grid.id = 'hb-collection-navigation-' + (++sequence);
    const wrapper = document.createElement('div');
    wrapper.dataset.hbCollectionNavigation = '';
    grid.before(wrapper);
    wrapper.append(grid);
    const mobile = matchMedia('(max-width:749px)');
    const reducedMotion = matchMedia('(prefers-reduced-motion:reduce)');
    let frame = 0;

    function makeButton(direction) {
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.hbCollectionArrow = direction;
      button.setAttribute('aria-label', direction === 'previous' ? 'Faire défiler les collections précédentes' : 'Faire défiler les collections suivantes');
      button.setAttribute('aria-controls', grid.id);
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', direction === 'previous' ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7');
      svg.append(path); button.append(svg);
      button.addEventListener('click', event => {
        event.preventDefault();
        // Les flèches ne déclenchent jamais le contrôleur de sélection.
        event.stopPropagation();
        const card = visibleCards()[0];
        const gap = parseFloat(getComputedStyle(grid).columnGap) || 0;
        const step = card ? card.getBoundingClientRect().width + gap : grid.clientWidth;
        const sign = direction === 'previous' ? -1 : 1;
        const rtl = getComputedStyle(grid).direction === 'rtl' ? -1 : 1;
        grid.scrollBy({left:sign * rtl * step, behavior:reducedMotion.matches ? 'auto' : 'smooth'});
      });
      return button;
    }
    const previous = makeButton('previous');
    const next = makeButton('next');
    wrapper.prepend(previous); wrapper.append(next);

    function visibleCards() {
      return Array.from(grid.children).filter(card => card.hasAttribute('data-hb-collection-strip-card') &&
        !card.hidden && getComputedStyle(card).display !== 'none');
    }
    function setAvailable(button, available, other) {
      if (!available && button.getRootNode().activeElement === button && !other.disabled) other.focus({preventScroll:true});
      button.disabled = !available;
      button.setAttribute('aria-hidden', String(!available));
      button.dataset.unavailable = String(!available);
    }
    function update() {
      frame = 0;
      if (!grid.isConnected) return;
      const cards = visibleCards();
      const gap = parseFloat(getComputedStyle(grid).columnGap) || 0;
      const total = cards.reduce((sum, card) => sum + card.getBoundingClientRect().width, 0) + Math.max(0,cards.length - 1) * gap + 6;
      const overflow = mobile.matches && cards.length > 1 && total > wrapper.clientWidth + 1;
      const state = String(overflow);
      if (wrapper.dataset.overflow !== state) wrapper.dataset.overflow = state;
      const max = Math.max(0, grid.scrollWidth - grid.clientWidth);
      const position = Math.min(max, Math.abs(grid.scrollLeft));
      setAvailable(previous, overflow && position > 2, next);
      setAvailable(next, overflow && position < max - 2, previous);
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(update); }
    const resize = new ResizeObserver(schedule);
    resize.observe(grid); resize.observe(wrapper);
    const changes = new MutationObserver(schedule);
    changes.observe(grid, {childList:true,subtree:true,attributes:true,attributeFilter:['hidden','style','class']});
    grid.addEventListener('scroll',schedule,{passive:true});
    grid.addEventListener('load',schedule,true);
    mobile.addEventListener('change',schedule);
    collectionNavigators.set(grid, {schedule, destroy() {
      resize.disconnect(); changes.disconnect(); cancelAnimationFrame(frame);
      grid.removeEventListener('scroll',schedule); grid.removeEventListener('load',schedule,true);
      mobile.removeEventListener('change',schedule);
    }});
    schedule();
  }

  function keepCollectionNavigation(grid) {
    if (mobileNavigation.has(grid)) return;
    mobileNavigation.add(grid);

    function selection(event) {
      if (!matchMedia('(max-width:749px)').matches || event.defaultPrevented ||
          event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return null;
      const card = event.target.closest?.('[data-hb-collection-strip-card]');
      if (!card || card.parentElement !== grid) return null;
      // Réutiliser le contrôleur de la page : mêmes produits, filtres et requêtes.
      // Les cartes qui ouvrent une autre page gardent leur navigation normale.
      let controller = grid.parentElement;
      while (controller) {
        if (controller.localName.startsWith('hb-') && typeof controller.activate === 'function' &&
            Array.isArray(controller.tabs) && Array.isArray(controller.panels)) {
          const index = controller.tabs.indexOf(card);
          if (index >= 0 && controller.panels[index]) return {controller, index};
        }
        controller = controller.parentElement;
      }
      return null;
    }

    function activate(event, controller, index, focus) {
      event.preventDefault();
      // Arrêter le gestionnaire historique qui fait défiler la page aux produits.
      event.stopPropagation();
      controller.activate(index);
      const card = controller.tabs[index];
      if (focus) card.focus({preventScroll:true});
      const bounds = grid.getBoundingClientRect();
      const item = card.getBoundingClientRect();
      const delta = item.left < bounds.left + 4 ? item.left - bounds.left - 4 :
        item.right > bounds.right - 4 ? item.right - bounds.right + 4 : 0;
      // Déplacer uniquement la barre horizontale, jamais le défilement vertical.
      if (delta) grid.scrollBy({left:delta, behavior:matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth'});
    }

    grid.addEventListener('click', event => {
      if (event.button !== 0) return;
      const selected = selection(event);
      if (selected) activate(event, selected.controller, selected.index, false);
    }, true);
    grid.addEventListener('keydown', event => {
      const selected = selection(event);
      if (!selected) return;
      const {controller, index} = selected;
      let next;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % controller.tabs.length;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index + controller.tabs.length - 1) % controller.tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = controller.tabs.length - 1;
      if (event.key === ' ') next = index;
      if (next !== undefined && controller.panels[next]) activate(event, controller, next, true);
    }, true);
  }

  function setTitle(grid) {
    if (!isGrid(grid)) return;
    setMobileStrip(grid);
    let heading = grids.get(grid);
    if (!heading?.isConnected) {
      const scope = grid.closest('section,.collection-list-wrapper') || grid.parentElement;
      // Réutiliser le titre statique des anciennes pages, jamais celui d'un produit.
      heading = Array.from(scope.querySelectorAll('h2[data-hb-collections-heading],h2[id*="-collections-title-"],h2.collection-list-title')).find(node =>
        !grid.contains(node) && Boolean(node.compareDocumentPosition(grid) & Node.DOCUMENT_POSITION_FOLLOWING) &&
        !Array.from(grids.entries()).some(([other,used]) => other !== grid && used === node)
      );
      if (!heading) {
        heading = document.createElement('h2');
        heading.id = 'hb-collections-heading-' + (++sequence);
        const anchor = grid.closest('[data-hb-collection-navigation]') || (grid.parentElement.matches('slider-component') ? grid.parentElement : grid);
        anchor.before(heading);
      }
      heading.dataset.hbCollectionsHeading = '';
      grids.set(grid, heading);
    }
    const text = typeof config.text === 'string' ? config.text.trim() : 'Nos collections';
    if (heading.textContent !== text) heading.textContent = text;
    heading.hidden = config.enabled === false || !text;
    heading.dataset.hbchMode = document.documentElement.dataset.hbColorMode || 'dark';
    // Les anciennes pages ont des règles !important propres. Ces propriétés
    // ciblent uniquement le nouveau titre, y compris dans le bloc de droite.
    const styles = {
      display:heading.hidden ? 'none' : 'block',
      'font-family':'var(--hbch-font, inherit)',
      'font-weight':'var(--hbch-weight, 700)',
      'font-style':'var(--hbch-style, normal)',
      'font-size':'var(--hbch-current-size, var(--hbch-desktop-size, 32px))',
      color:'var(--hbch-current-color, var(--hbch-dark-color, #f5f7fb))',
      background:'transparent',
      'line-height':'1.2',
      'letter-spacing':'normal',
      'text-transform':'none',
      'text-align':'var(--hbch-align, left)',
      'overflow-wrap':'anywhere',
      margin:'0 0 var(--hbch-gap, 18px)',
      padding:'0',width:'100%',height:'auto',
      'max-width':'none','min-width':'0',
      border:'0',opacity:'1'
    };
    Object.entries(styles).forEach(([name,value])=>heading.style.setProperty(name,value,'important'));
  }

  function registerShadow(host) {
    const shadow = host.shadowRoot;
    if (!shadow) return;
    if (!shadow.querySelector('[data-hb-collections-heading-styles]')) {
      const link = document.createElement('link');
      link.rel = 'stylesheet'; link.href = config.stylesheet;
      link.dataset.hbCollectionsHeadingStyles = '';
      shadow.prepend(link);
    }
    if (!shadows.has(host)) {
      const observer = new MutationObserver(onMutations);
      observer.observe(shadow, {childList:true,subtree:true});
      shadows.set(host, observer);
    }
    scan(shadow);
  }

  function scan(node) {
    if (!(node instanceof Element) && !(node instanceof ShadowRoot) && node !== document) return;
    const parentGrid = node.closest?.(selector);
    if (parentGrid) setMobileStrip(parentGrid);
    if (node.matches?.(selector)) setTitle(node);
    node.querySelectorAll(selector).forEach(setTitle);
    if (node.matches?.('.hbui-inline-page')) registerShadow(node);
    node.querySelectorAll('.hbui-inline-page').forEach(registerShadow);
  }

  function cleanup() {
    collectionNavigators.forEach((navigation,grid) => { if (!grid.isConnected) { navigation.destroy(); collectionNavigators.delete(grid); } });
    grids.forEach((_,grid) => { if (!grid.isConnected) grids.delete(grid); });
    shadows.forEach((observer,host) => { if (!host.isConnected) {observer.disconnect();shadows.delete(host);} });
  }

  function onMutations(records) {
    records.forEach(record=>record.addedNodes.forEach(scan));
    cleanup();
  }

  function refresh() {
    if (!readConfig()) return;
    scan(document);
    grids.forEach((_,grid)=>setTitle(grid));
    cleanup();
  }

  function syncMode() {
    const mode = document.documentElement.dataset.hbColorMode || 'dark';
    grids.forEach(heading=>{heading.dataset.hbchMode=mode;});
  }

  window.HBCollectionHeadings = {refresh,registerShadow};
  function start() {
    if (!readConfig()) return;
    scan(document);
    new MutationObserver(onMutations).observe(document.body,{childList:true,subtree:true});
    new MutationObserver(syncMode).observe(document.documentElement,{attributes:true,attributeFilter:['data-hb-color-mode']});
    document.addEventListener('shopify:section:load',refresh);
    document.addEventListener('hb:color-mode',syncMode);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
